import { PromotionBanner } from 'lib/_types'
import { yayApi } from '../baseApi'

export const promotionApi = yayApi.injectEndpoints({
  endpoints: (build) => ({
    getPromotions: build.query<
      PromotionBanner[],
      { page?: number; limit?: number }
    >({
      query: ({ page = 0, limit = 9 }) => ({
        url: `/v1/promotions`,
        params: {
          page,
          limit,
        },
      }),
      transformResponse: (x: {
        promotions: PromotionBanner[]
        result: 'success'
      }) => x?.promotions ?? [],
    }),
  }),
  overrideExisting: false,
})

export const { useGetPromotionsQuery } = promotionApi
